export const CATEGORY_PAGE_SLUGS = [
  'sanitaryware',
  'tapware',
  'showers',
  'basins',
  'kitchen-sinks-accessories',
  'laundry-tubs',
  'spare-parts',
  'baths',
  'valves-fittings',
  'bathroom-accessories',
  "plumber's-favourites",
];

export const SPARE_PARTS_SUBCATEGORY_SLUGS = [
  'bath-spare-parts',
  'basin-spare-parts',
  'shower-spare-parts',
  'tapware-spare-parts',
  'toilet-spare-parts',
  'valve-spare-parts',
  'kitchen-laundry-spare-parts',
];

export const BRAND_PAGE_SLUGS = [
  'caroma',
  'clark',
  'dorf',
  'fowler',
  'stylus',
  'methven',
  'leak-smartshield',
];

export const normalizeCategorySlug = (slug: string) =>
  slug.toLowerCase().replace(/'/g, '').replace(/\s+/g, '-');

export const toCategoryTitleCase = (slug: string) =>
  slug.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

export const buildSubCategoryLvl1Filter = (
  parentSlug: string,
  subCategorySlug: string,
  localeKey: string,
) => {
  const parentTitle = toCategoryTitleCase(normalizeCategorySlug(parentSlug));
  const childTitle = toCategoryTitleCase(normalizeCategorySlug(subCategorySlug));
  return `categories.${localeKey}.lvl1:"${parentTitle} > ${childTitle}"`;
};
